import { Pedido } from '../shared/entity/Pedido';
import { GetManyParams, GetOneParams } from '../shared/types/TypeormTypes';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';

const BASE_URL = '/pedido';

class pedidoApi {
  async getOne(query: GetOneParams<Pedido>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Pedido não encontrado.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getMany(query?: GetManyParams<Pedido>) {
    try {
      let res = await api.post<Pedido[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  // async getMany(query: FindManyReq<Pedido>) {
  //   try {
  //     let res = await api.post<Pedido[]>(BASE_URL + '/get', { query });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  // async count(query: FindManyReq<Pedido>) {
  //   try {
  //     let res = await api.post<number>(BASE_URL + '/count', { query });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  // async update(where: Partial<Pedido>, update: Partial<Pedido>) {
  //   try {
  //     let res = await api.put(BASE_URL, { update }, { params: where });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  async insert(pedido: Partial<Pedido>) {
    try {
      let res = await api.post(BASE_URL, { pedido });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new pedidoApi();
